const ChangePlan = {
  mounted() {
    this.handleClick = (e) => {
      const lineBreak = "%0D%0A";
      const emailAddress = "support@collava.app";
      const subject = "Change Plan Request";
      const body = `Please change my plan from (Zoom/Amplify): ${lineBreak} To (Zoom/Amplify):  ${lineBreak}To be charged every (month/year): ${lineBreak} The e-mail used during the subscription was:`;
      const mailtoLink = `mailto:${emailAddress}?subject=${subject}&body=${body}`;
      this.el.href = mailtoLink;
    };
    this.el.addEventListener("click", this.handleClick);
  },
  destroyed() {
    this.el.removeEventListener("click", this.handleClick);
  },
};

export default ChangePlan;
